import React, { useState, useEffect } from 'react';
import {Modal} from 'react-bootstrap';
import Button from '../../Button'
import "react-datepicker/dist/react-datepicker.css";
import './DataTable.css';
import Filter from './Filter';
import PopupBody from './PopupBody';
import Pagination from './Pagination';
import TableRow from './TableRow';
import { Link } from 'react-router-dom'
import SkeletonTable from './SkeletonTable';
import DrawerPane from './DrawerPane';

const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)'
    }
};

const DataTable = (props) => {
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(props.loading);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalUrl, setModalUrl] = useState(props.url);
    const [modalFields, setModalFields] = useState(props.fields);
    const [modalFooter, setModalFooter] = useState(props.footer);
    const [modalTitle, setModalTitle] = useState(props.title);
    const [modalId, setModalId] = useState(props.id);
    const [drawerIsOpen, setDrawerIsOpen] = useState(false);
    const [drawerUrl, setDrawerUrl] = useState(props.url);
    const [drawerFields, setDrawerFields] = useState(props.fields);
    const [drawerFooter, setDrawerFooter] = useState(props.footer);
    const [drawerTitle, setDrawerTitle] = useState(props.title);
    const [drawerId, setDrawerId] = useState(props.id);

    useEffect(() => {
        setLoading(props.loading);
    }, [props.loading]);

    // Only call onPageChange when page changes, not on every render
    const handlePageChange = (newPage) => {
        setPage(newPage);
        if (props.onPageChange) {
            props.onPageChange(newPage);
        }
    };

    const handlePopup = (url, fields, footer, title, type, id) => {
        if (type === 'popup') {
            setModalIsOpen(true);
            setModalUrl(url);
            setModalFields(fields);
            setModalFooter(footer);
            setModalTitle(title);
            setModalId(id);
        } else if (type === 'drawer') {
            setDrawerIsOpen(true);
            setDrawerUrl(url);
            // setDrawerFields(fields);
            // setDrawerFooter(footer);
            // setDrawerTitle(title);
            setDrawerId(id);
        }
    };

    const handleModalCancel = () => {
        setModalIsOpen(false);
    };

    let prefs = {};
    if (props.childProps !== undefined && props.childProps.prefs !== undefined) {
        prefs = props.childProps.prefs;
    }

    let idcol = null;
    props.metadata?.forEach((col) => {
        if (col.type === 'primary') {
            idcol = col.source;
        }
    });

    return (
        <div className="card">
            <Modal show={modalIsOpen} size="lg" onHide={handleModalCancel} style={customStyles}>
                <Modal.Header closeButton>
                    <Modal.Title>{ props.modalTitle }</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PopupBody
                        fields = {modalFields}
                        token_name = ""
                        url = {modalUrl}
                        id = {modalId}
                        footer = {modalFooter}
                        childProps={props.childProps}
                        prefs = {prefs}
                        loading = {loading}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <Button bsStyle="cancel" value="Close" onClick={handleModalCancel}/>
                    </div>
                </Modal.Footer>
            </Modal>
            <DrawerPane url={drawerUrl} id={drawerId} open={drawerIsOpen} onClose={() => setDrawerIsOpen(false)}>
                {props.view.component}
            </DrawerPane>
            <div className="row">
                <div className="col-lg-12">
                    <Filter
                        userfilter = {props.userfilter}
                        userFilterExpandable = {props.userFilterExpandable}
                        userFilterSimple = {props.userFilterSimple}
                        userFilterAdvanced = {props.userFilterAdvanced}
                        onFilter = { props.onFilter }
                        queryParams = {props.queryParams}
                        loading = { loading }
                        url = { props.url }
                        urlattrs = { props.urlattrs }
                        download = { props.download }
                        data={props.data}
                        prefs = {prefs}
                        rowsPerPage = {props.rowsPerPage}
                        filterColumnWidth = {props.filterColumnWidth}
                    />
                </div>
            </div>
            <div className="row card-body p-0 pb-3 text-center">
                <div className="col-lg-12">     
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        {props.addButtonLink ? (
                            <div>
                                <Link to={props.addButtonLink} className="btn btn-primary">{props.addButtonText}</Link>
                            </div>
                        ) : (
                            <div></div>
                        )}
                        <div>
                            <Pagination 
                                loading={loading}
                                page={page} 
                                total={props.total} 
                                onPageChange={handlePageChange}
                                rowsPerPage={props.rowsPerPage}
                            />
                        </div>
                    </div>
                    <table id={props.id} className='table table-bordered table-striped'>
                        <thead>
                            <tr>
                                {props.metadata.map((col, index) => (
                                    col.visible !== false && (
                                        <th key={index}>{col.label}</th>
                                    )
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <SkeletonTable columns={props.metadata.length} />
                            ) : (
                                props.data?.data?.length === 0 ? (
                                    <tr>
                                        <td colSpan={props.metadata.length}>No data in this view</td>
                                    </tr>
                                ) : (
                                    props.data?.data?.map((row, index) => {
                                        let id = row[idcol];
                                        return (
                                        <TableRow
                                            key={index}
                                            row={row}
                                            metadata={props.metadata}
                                            handlePopup={handlePopup}
                                            id={id}
                                            onclick={props.onclick}
                                            link={props.link}
                                            view={props.view}
                                            remotemeta={props.data?.metadata}
                                            prefs={prefs}
                                            handleDelete={props.handleDelete}
                                            />
                                        );
                                    })
                                )
                            )}
                        </tbody>
                    </table>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Pagination 
                            loading={loading}
                            page={page} 
                            total={props.total} 
                            onPageChange={handlePageChange}
                            rowsPerPage={props.rowsPerPage}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DataTable;
